import { useState } from "react";
import { datasetLabel } from "../helpers/datasetLabels";

const STAGE_CLOSED = 'closed';
const STAGE_SYNC_CONFIRM = 'sync-confirm';
const STAGE_UNSYNC_WARNING = 'unsync-warning';

const labelFor = (dataset, datasetContactNames) => {
  const name = datasetContactNames?.[dataset];
  return name ? `${name} (${datasetLabel(dataset)})` : datasetLabel(dataset);
};

export function useLinkedinCrossDatasetConfirm(currentDataset) {
  const [stage, setStage] = useState(STAGE_CLOSED);
  const [otherContactLabels, setOtherContactLabels] = useState([]);
  const [currentContactLabel, setCurrentContactLabel] = useState('');
  const [resolve, setResolve] = useState(null);

  const confirmLinkedinChange = (datasets, originalValue, newValue, datasetContactNames) => {
    const changed = (originalValue || '') !== (newValue || '');
    const otherDatasets = (datasets || []).filter((dataset) => dataset !== currentDataset);

    if (!changed || otherDatasets.length === 0) {
      return Promise.resolve(null);
    }

    setCurrentContactLabel(labelFor(currentDataset, datasetContactNames));
    setOtherContactLabels(otherDatasets.map((dataset) => labelFor(dataset, datasetContactNames)));

    return new Promise((res) => {
      setResolve(() => res);
      setStage(STAGE_SYNC_CONFIRM);
    });
  };

  const handleSyncConfirm = () => {
    resolve?.('sync');
    setStage(STAGE_CLOSED);
    setResolve(null);
  };

  const handleSyncDecline = () => {
    setStage(STAGE_UNSYNC_WARNING);
  };

  const handleSyncAbort = () => {
    resolve?.('abort');
    setStage(STAGE_CLOSED);
    setResolve(null);
  };

  const handleUnsyncConfirm = () => {
    resolve?.('unsync');
    setStage(STAGE_CLOSED);
    setResolve(null);
  };

  const handleUnsyncDecline = () => {
    setStage(STAGE_SYNC_CONFIRM);
  };

  return {
    linkedinConfirmDialogProps: {
      open: stage === STAGE_SYNC_CONFIRM,
      currentContactLabel,
      otherContactLabels,
      onConfirm: handleSyncConfirm,
      onCancel: handleSyncDecline,
      onClose: handleSyncAbort,
    },
    linkedinUnsyncWarningDialogProps: {
      open: stage === STAGE_UNSYNC_WARNING,
      currentDatasetLabel: datasetLabel(currentDataset),
      onConfirm: handleUnsyncConfirm,
      onCancel: handleUnsyncDecline,
    },
    confirmLinkedinChange,
  };
}

export default useLinkedinCrossDatasetConfirm;